import "../../tailwind.css";
import TrademinHomeAboutSection from "./TrademinHomeAboutSection";
import TrademinWelcomeBanner from "./TrademinWelcomeBanner";
import TrademinQuickContact from "./TrademinQuickContact";
import TrademinMeetTheTeam from "./TrademinMeetTheTeam";
import TrademinRequestInformation from "./TrademinRequestInformation";
import TrademinServicesSection from "./TrademinServicesSection";
import SectionBreak from "./SectionBreak";
import SEO from "../Components/SEO";

const Home = () => {
  return (
    <>
      <SEO
        title="Trademin Ltd | Electrical & Mechanical Services"
        description="Trademin Ltd provides professional electrical and mechanical services in Ashburton and across Canterbury."
        canonical="https://www.trademin.co.nz/"
        ogTitle="Trademin Ltd | Electrical & Mechanical Services"
        ogDescription="Professional electrical and mechanical services delivered with quality, safety, and reliability."
      />

      <div className="welcome-container">
        <TrademinWelcomeBanner />
        <TrademinHomeAboutSection />
        <SectionBreak />
        <TrademinServicesSection />
        <TrademinQuickContact />
        <TrademinMeetTheTeam />
        <TrademinRequestInformation />
      </div>
    </>
  );
};

export default Home;
